import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/global.css'
import request from "@/request/request";
import XLSX from 'xlsx';
Vue.prototype.request = request
Vue.config.productionTip = false
Vue.use(ElementUI,{size:"mini"});
Vue.use(XLSX);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
